"use client";

import { useMemo } from "react";
import { useTable } from "spacetimedb/react";
import { toast } from "sonner";
import { tables } from "@/module_bindings";
import { useRowTransitions } from "@/hooks/spacetime/use-row-transitions";
import type { Organization } from "@/types/organization";
import type { OrgMemberRow } from "@/lib/stdb-map";

/** Spec event #4: my_memberships.role change for the current org. */
export function RoleChangedToasts({
  organization,
}: {
  organization: Organization | null;
}) {
  const [rows, isReady] = useTable(tables.my_memberships);
  const orgRows = useMemo(
    () =>
      organization
        ? rows.filter(
            (row: OrgMemberRow) => row.organizationId === organization.id,
          )
        : [],
    [rows, organization],
  );

  useRowTransitions<OrgMemberRow>({
    rows: orgRows,
    isReady,
    getId: (row) => row.id,
    getState: (row) => row.role,
    resetKey: organization?.id ?? null,
    onTransition: ({ next, row }) => {
      toast.info("Role Updated", {
        id: `role-changed-${row.id}-${next}`,
        description: `Your role is now ${next}.`,
      });
    },
  });

  return null;
}
